<div class="row">
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<video width="100%" height="auto" controls autoplay autoplay>
			  <source src="/assets/videos/facts_about_sleep.mp4" type="video/mp4">
			Your browser does not support the video tag.
			</video>
		</div>
	<div class="col-md-2"></div>
	
	<div class="col-md-2"></div>
		<div class="col-md-8">
			<p style="color : #002E46 !important;">
				We spend a large portion of our lives asleep, yet most of us understand very little about sleep.
				In the first part of the program, you will learn some basic physiology of sleep.
				Topics such as:


			</p>
			<ul style="list-style-type: none; ">
				<li style="color : #002E46 !important;">
					1. What happens during sleep?
				</li>
				<li style="color : #002E46 !important;">
					2. How much sleep do we need?
				</li>
				<li style="color : #002E46 !important;">
					3. Does sleep change as we age?
				</li>

			</ul>

			<mat-accordion class="example-headers-align" multi="false">
				<mat-expansion-panel class="ion-text-left">

					<mat-expansion-panel-header>

						<mat-panel-title style="font-weight: bold; color : #002E46 !important;">

							WHAT HAPPENS WHEN WE SLEEP?


						</mat-panel-title>

					</mat-expansion-panel-header>
					<p style="color : #002E46 !important;">
						Sleep is divided into 2 parts, <strong>NREM </strong>sleep, and <strong>REM </strong>sleep.

					</p>
					<br>
					<p style="color : #002E46 !important;">


						<strong>NREM </strong>dominates the EARLY part of the night, and it's subdivided into 3 stages.

					</p>
					<br>
					<p style="color : #002E46 !important;">

						<strong>Stage N1:</strong> is a transitional period when we doze off between awake and drowsiness
						<br>
						<strong>Stage N2:</strong> is considered light sleep and prepares us for deeper sleep <br>
						<strong>Stage N3:</strong>is deep sleep.
					</p>

					<br>
					<p style="color : #002E46 !important;">
						During the early part of our sleep, deep sleep periods are lengthier

					</p>
					<p>
						<br>

						<img src="http://tranqsleep.com/wp-content/uploads/2021/09/12.gif" width="100%" height="auto" style="background-color: white;">
					</p>



					<p style="color : #002E46 !important;">
						<br>
						The second half of the night is
						dominated by <strong>REM</strong> Sleep, especially
						in the early hours of the morning.

					</p>
					<p style="color : #002E46 !important;">
						<br>
						<img src="http://tranqsleep.com/wp-content/uploads/2021/09/22.gif" width="100%" height="auto"  style="background-color: white;">

						<br>
						<br>
					</p>
					<br>
					<p style="color : #002E46 !important;">

						Contrary to common belief, in REM the brain is quite active, and this is the stage where we
						experience most of our dreams.

					</p>
					<br>
					<p style="color : #002E46 !important;">
						Something to remember is that sleep grows lighter as the night progresses, therefore awakenings
						are more prone to occur during the second half of the night.
					</p>
					<br>


					<img src="http://tranqsleep.com/wp-content/uploads/2021/09/f2645eab0f72a49b1a40eb595bcffb6e.jpg"  width="100%" height="auto" >





					<mat-card style="background-color: #e9f3f1;">
						<mat-card-content>
							<mat-card-header>
								<mat-card-title style="font-weight: bold;" class="ion-text-center">Key Points</mat-card-title>

							</mat-card-header>

							<p style=" color: black; color : #002E46 !important;">
								It is normal to wake up several times at night, particularly when we shift from one sleep
								stage to another. However, normally we fall back to sleep within seconds or minutes.
								<br>
								<br>
							</p>
							<p style=" color: black; color : #002E46 !important;">
								Studies show that an individual wakes up an average of 6 times per night.
								<br> <br>
								So don’t worry if you wake up - it is part of the natural physiology of sleep. Worrying and
								stressing about it will only increase your anxiety and keep you awake.

							</p>
						</mat-card-content>
					</mat-card>

				</mat-expansion-panel>

				<!---->
				<mat-expansion-panel class="ion-text-left">

					<mat-expansion-panel-header>
						<mat-panel-title style="font-weight: bold; color : #002E46 !important;">
							HOW MUCH SLEEP DO WE NEED?
						</mat-panel-title>

					</mat-expansion-panel-header>

					<img
						src="http://tranqsleep.com/wp-content/uploads/2021/09/National_Sleep_Foundation_Sleep_Duration_Recommendations.jpg"  width="100%" height="auto" >



					<br>

					<p style="color : #002E46 !important;">
						As with many aspects of human biology, there is no one-size-fits-all approach to sleep. Some
						people get by with less sleep than others, which could be as little as 4 hours, whom we call short
						sleepers. Others require longer sleep, sometimes up to 10 hours, whom we call long sleepers.


					</p>
					<br>
					<p style="color : #002E46 !important;">


						Your need for sleep and your sleep patterns change as you age, but this varies significantly per
						individual. There is no magic number for <strong>“optimal hours of sleep”</strong> that works for
						everybody .

					</p>
					<br>
					<p style="color : #002E46 !important;">

						For your body to get the benefits of sleep, you need to get the <strong> “RIGHT AMOUNT OF
							SLEEP”</strong> per night.
						This amount changes depending on your genetics, age, and other external and internal factors.
					</p>
					<br>



					<mat-card style="background-color: #e9f3f1;">
						<mat-card-content>
							<mat-card-header>
								<mat-card-title style="font-weight: bold; color : #002E46 !important;" class="ion-text-center">Key Points</mat-card-title>

							</mat-card-header>


							<p style="color: black; color : #002E46 !important;">
								The “right amount” is the time one needs to have a refreshing sleep and to have adequate
								daytime energy to function throughout the day. It is important to note that the <strong>QUALITY
									OF
									SLEEP</strong> is more important than the quantity.
							</p>
							<br>

							<p style=" color: black; color : #002E46 !important;">
								One important thing to keep in mind is that daytime functioning for people with poor sleep is
								affected by many other factors such as level of stress, nutritional intake, the amount of
								exercise,
								medical and psychiatric conditions, emotional state, and the degree of social support.
							</p>
							<br>
							<p style=" color: black; font-weight: bold; color : #002E46 !important;">
								It is quite common for insomniacs to mistakenly attribute their daytime functioning entirely to
								their lack of sleep.
							</p>

							<br>

						</mat-card-content>
					</mat-card>

				</mat-expansion-panel>
				<!---->
			</mat-accordion>			
				</div>
			<div class="col-md-2"></div>
</div>
